<template>
    <v-container>
        <v-row class="text-h3 text--secondary font-weight-thin" align="center" justify="center">
            <span class="header">
                Keine Daten gefunden!
            </span>
        </v-row>

        <v-row class="text-body-1 text--disabled" align="center" justify="center">
            <span class="body">
                <v-icon class="text--disabled">mdi-alert-circle-outline</v-icon> Es konnten leider keine Datensätze für sie gefunden werden. Bitte ändern sie ihre Suchfilter oder kehren sie zur <router-link :to="{name: 'Home'}">Startseite</router-link> zurück.
            </span>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'NoData'
    };
</script>

<style scoped>

.header {
    padding: 50px 0px;
}

.body {
    /* empty */
}

</style>
